module.exports = __webpack_public_path__ + "img/cooperation_unit_03.1ae8aef5.png";